import Template from "../../components/Template";
import { useNavigate } from 'react-router-dom';
import { useNavigation } from '../../context/NavigationContext';
import React, { useState, useEffect, useRef } from "react";
import api from "../../services/api";
import config from "../../config";
import * as XLSX from "xlsx";
import AlertDialog from "../../components/AlertDialog";
import { Link } from "react-router-dom";
import usePermission from "../../hooks/usePermission";
import useListFilterState from "../../hooks/useListFilterState";

import useRequisicaoMaisRecente from '../../hooks/useRequisicaoMaisRecente';
const Clientes = () => {
    const navigate = useNavigate();
    const { updateMenu } = useNavigation();
    const [clientes, setClientes] = useState([]);
    const [selectedDoc, setSelectedDoc] = useState(null); // Estado para o documento selecionado
    const [showDialog, setShowDialog] = useState(false); // Estado para controlar o modal    
    const [selectedPdf, setSelectedPdf] = useState("");
    const [currentPage, setCurrentPage] = useState(1); // Página atual
    const [totalRecords, setTotalRecords] = useState(0); // Total de registros    
    const menuRef = useRef(null);
    const menuFiltrarRef = useRef(null);
    const buttonRef = useRef(null);
    const buttonFiltrarRef = useRef(null);
    const [showSuccessDialog, setShowSuccessDialog] = useState(false);

    const { filters, setFilters, searchTerm, setSearchTerm, isSearchActive, setIsSearchActive, pageSize, setPageSize, hasRestoredFilters, clearPersistedState } = useListFilterState('clientes', {
        nome: "",
        cnpj: "",
    });
    const [filteredClientes, setFilteredClientes] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (hasRestoredFilters()) {
            applyFilters();
            return;
        }
        fetchClientes(currentPage, pageSize);
    }, [currentPage]);

    useEffect(() => {
        // Sempre que o termo de pesquisa mudar, atualize os documentos filtrados
        if (searchTerm.trim() === "") {
            setFilteredClientes(clientes); // Se não houver termo de pesquisa, mostre todos os documentos
        } else {
            setFilteredClientes(
                clientes.filter((doc) =>
                    doc.nome.toLowerCase().includes(searchTerm.toLowerCase())
                )
            );
        }
    }, [searchTerm, clientes]);

    // Filtros efetivamente aplicados pelo botao "Filtrar". Sao reenviados em toda
    // troca de pagina e de "resultados por pagina": antes a paginacao refazia a
    // busca sem filtro nenhum e a lista voltava silenciosamente ao conjunto completo.
    const appliedFiltersRef = useRef({});

    // Descarta respostas de filtros que já foram superados por outro mais novo:
    // sem isto, a resposta lenta de um filtro anterior sobrescrevia a tela.
    const requisicaoMaisRecente = useRequisicaoMaisRecente();

    const fetchClientes = async (page, size) => {
        try {
            const params = new URLSearchParams({ page, pageSize: size });
            Object.entries(appliedFiltersRef.current).forEach(([chave, valor]) => {
                if (valor !== undefined && valor !== null && valor !== "") params.set(chave, valor);
            });
            const idRequisicao = requisicaoMaisRecente.iniciar();
            const response = await api.get(`/clientes?${params.toString()}`);
            // Chegou atrasada e ja foi superada por outro filtro: descarta.
            if (!requisicaoMaisRecente.ehAtual(idRequisicao)) return;

            setClientes(response.data.records);
            setTotalRecords(response.data.total);
            setPageSize(size);
        } catch (error) {
            console.error("Erro ao carregar dados:", error);
        }
    };

    const fetchFilteredClientes = async (query) => {
        try {
            const params = new URLSearchParams(query).toString();
            const idRequisicao = requisicaoMaisRecente.iniciar();
            const response = await api.get(`/clientes?${params}`);
            // Chegou atrasada e ja foi superada por outro filtro: descarta.
            if (!requisicaoMaisRecente.ehAtual(idRequisicao)) return;


            setClientes(response.data.records);
            setTotalRecords(response.data.total);
            setCurrentPage(1);
        } catch (error) {
            console.error("Erro ao aplicar filtros:", error);
        }
    };

    const handleNavigateCadastrar = async (e) => {
        e.preventDefault();
        try {
            navigate('/clientes/cadastrar');
        } catch (err) {
            console.error('Cliente Error:', err);
            alert(err.response?.data?.msg || 'Erro ao ir para o cadastro');
        }
    };

    const handleCloseDialog = () => {
        setSelectedDoc(null);
        setShowDialog(false);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const totalPages = Math.ceil(totalRecords / pageSize);
    const startRecord = totalRecords > 0 ? (currentPage - 1) * pageSize + 1 : 0;
    const endRecord = Math.min(currentPage * pageSize, totalRecords);

    const pageWindowSize = 5;
    // Mantem a janela cheia tambem nas ultimas paginas (antes ela encolhia).
    const startPage = Math.max(1, Math.min(currentPage - Math.floor(pageWindowSize / 2), totalPages - pageWindowSize + 1));
    const endPage = Math.min(totalPages, startPage + pageWindowSize - 1);

    const pageNumbers = Array.from(
        { length: endPage - startPage + 1 },
        (_, i) => startPage + i
    );

    const [columns, setColumns] = useState([
        {
            id: "id",
            label: "ID",
            visible: true,
            formatter: (value) => (
                <Link to={`/clientes/editar/${value}`} className="text-stone-600 hover:underline">
                    {value}
                </Link>
            ),
        },
        {
            id: "nome",
            label: "Nome",
            visible: true,
            formatter: (value) => value

        },
        {
            id: "cnpj",
            label: "CNPJ",
            visible: true,
            formatter: (value) =>
                value ? value : "",
        }

    ]);
    const [menuOpen, setMenuOpen] = useState(false);
    const [menuFiltrarOpen, setMenuFiltrarOpen] = useState(false);

    const toggleColumnVisibility = (id) => {
        setColumns((prevColumns) =>
            prevColumns.map((col) =>
                col.id === id ? { ...col, visible: !col.visible } : col
            )
        );
    };

    // Função para fechar o menu ao clicar fora
    const handleClickOutside = (event) => {
        if (
            buttonRef.current &&
            !buttonRef.current.contains(event.target) &&
            buttonFiltrarRef.current &&
            !buttonFiltrarRef.current.contains(event.target)
        ) {
            setMenuOpen(null);
        }
    };

    useEffect(() => {
        if (menuOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        } else {
            document.removeEventListener("mousedown", handleClickOutside);
        }

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);

        };
    }, [menuOpen]);

    const handleMenuClick = (event) => {
        event.stopPropagation();
    };

    const applyFilters = () => {
        appliedFiltersRef.current = { ...filters };
        setCurrentPage(1);
        const query = {
            ...filters,
            page: 1,
            pageSize,
        };

        fetchFilteredClientes(query);
    };

    const clearFilters = () => {
        clearPersistedState();
        appliedFiltersRef.current = {};
        setSearchTerm("");
        setCurrentPage(1);

        setFilters({
            nome: "",
            cnpj: "",
        });
        fetchClientes(1, pageSize); // Restaura os dados padrão
    };

    const handleSearch = () => {
        appliedFiltersRef.current = { ...filters };
        setCurrentPage(1); // Reinicia para a primeira página
        const query = {
            ...filters,
            page: 1,
            pageSize,
        };
        fetchFilteredClientes(query); // Executa a busca com o termo atual
    };

    // Função para exportar a tabela
    const exportToExcel = () => {
        if (clientes.length === 0) {
            setMessage('Não há dados para exportar!')
            setShowSuccessDialog(true);
            return;
        }

        // Mapeia os dados da tabela para um formato plano
        const dataToExport = clientes.map((doc) => {
            const row = {};
            columns.forEach((col) => {
                if (col.visible) {
                    // Formatters de coluna que devolvem JSX (links, botoes, checkboxes)
                    // viravam "[object Object]" na planilha: nesses casos exporta o valor bruto.
                    const formatado = col.formatter ? col.formatter(doc[col.id], doc) : doc[col.id];
                    row[col.label] = (formatado && typeof formatado === 'object') ? doc[col.id] : formatado;
                }
            });
            return row;
        });

        // Cria uma nova planilha do Excel
        const worksheet = XLSX.utils.json_to_sheet(dataToExport);

        // Cria um novo workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");

        // Exporta o arquivo
        XLSX.writeFile(workbook, "clientes.xlsx");
    };

    return (
        <Template>
            <div className="h-auto w-full p-4 md:p-8 flex flex-col gap-6">
                <div className="flex flex-wrap justify-between items-center gap-4">
                    <div className="text-stone-800 text-xl md:text-2xl font-medium font-['Inter']">Clientes</div>
                </div>
                <div className="flex flex-wrap gap-2 md:gap-4 items-center">
                    <div className="flex-grow min-w-0 flex items-center gap-2">
                        <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight">Ver</div>
                        <select
                            className="w-20 h-8 pl-2 pr-2 py-1 bg-white rounded-md border border-slate-300 text-sm text-slate-700"
                            value={pageSize}
                            onChange={(e) => {
                                const newPageSize = parseInt(e.target.value, 10);
                                setPageSize(newPageSize);
                                setCurrentPage(1);
                                fetchClientes(1, newPageSize);
                            }}
                        >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                            <option value={100}>100</option>
                        </select>
                        <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-tight">Resultados</div>
                    </div>
                    <div className="flex flex-wrap gap-2 flex-none w-full md:w-auto">
                        <div ref={buttonRef} className="relative justify-end items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "colunas" ? null : "colunas")}>
                            <div className="justify-start items-center gap-2 flex" >
                                <img className="w-6 h-6 relative " src="images/icon/columns.png" />
                                <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Colunas</div>
                            </div>
                            <img className="w-6 h-4 px-1 justify-center items-center flex" src="images/icon/chevron-down.png" />
                            {menuOpen === "colunas" && (
                                <div className="absolute top-full left-0 mt-2 w-48 bg-white border border-gray-300 rounded-md shadow-lg z-50"
                                    style={{
                                        zIndex: 9999, // Garante que está acima de outros elementos
                                    }}
                                    onClick={handleMenuClick} // Impede que o clique feche o menu
                                >
                                    <div className="p-4 flex flex-col gap-3">
                                        {columns.map((col) => (
                                            <div
                                                key={col.id}
                                                className="flex items-center gap-2"
                                            >
                                                <input
                                                    type="checkbox"
                                                    id={col.id}
                                                    checked={col.visible}
                                                    onChange={() =>
                                                        toggleColumnVisibility(col.id)
                                                    }
                                                />
                                                <label
                                                    htmlFor={col.id}
                                                    className="text-sm text-gray-700"
                                                >
                                                    {col.label}
                                                </label>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            )}
                        </div>
                        <div ref={buttonFiltrarRef} className="relative justify-start items-center gap-1 flex cursor-pointer" onClick={() => setMenuOpen(menuOpen === "filtro" ? null : "filtro")} >
                            <div className="justify-start items-center gap-2 flex">
                                <img className="w-8 h-8 px-0.5 py-[3px] justify-center items-center flex" src="images/icon/filter.png" />
                                <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Filtrar</div>
                            </div>
                            <img className="w-6 h-4 px-1 justify-center items-center flex" src="images/icon/chevron-down.png" />
                            {/* Menu Suspenso */}
                            {menuOpen === "filtro" && (
                                <div
                                    className="absolute top-full left-0 mt-2 w-[350px] bg-white rounded-md shadow-lg z-50 p-4 border border-gray-300"
                                    style={{ zIndex: 9999 }}
                                    onClick={handleMenuClick} // Impede que o clique feche o menu
                                >
                                    <div className="flex flex-col gap-4">
                                        <div className="self-stretch justify-start items-center gap-2.5 inline-flex">
                                            <div className="grow shrink basis-0 text-stone-800 text-xl font-medium">
                                                Filtrar
                                            </div>
                                        </div>

                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium leading-tight">
                                                Nome
                                            </div>
                                            <input
                                                type="text"
                                                name="nome"
                                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                placeholder="Digite o nome do cliente"
                                                value={filters.nome}
                                                onChange={(e) =>
                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        nome: e.target.value,
                                                    }))
                                                }
                                            />
                                        </div>

                                        <div className="flex flex-col gap-1.5">
                                            <div className="text-slate-700 text-sm font-medium leading-tight">
                                                CNPJ
                                            </div>
                                            <input
                                                type="text"
                                                name="cnpj"
                                                className="w-full px-3 py-2 bg-white rounded-md border border-slate-300 text-base text-slate-700"
                                                placeholder="Digite o CNPJ"
                                                value={filters.cnpj}
                                                onChange={(e) =>
                                                    setFilters((prev) => ({
                                                        ...prev,
                                                        cnpj: e.target.value,
                                                    }))
                                                }
                                            />
                                        </div>

                                        <div className="self-stretch flex items-center justify-between gap-4 mt-4">
                                            <button
                                                className="px-4 py-2 w-full bg-white rounded-md border border-stone-500 justify-center items-center gap-2 flex"
                                                onClick={clearFilters}
                                            >
                                                <img className="w-4 h-4 relative" src="images/icon/eraser.png" />
                                                <div className="text-stone-500 text-sm font-medium font-['Inter'] leading-normal" >Limpar</div>
                                            </button>
                                            <button
                                                className="px-4 py-2 w-full bg-stone-600 rounded-md justify-center items-center gap-2 flex"
                                                onClick={applyFilters}
                                            >
                                                <img className="w-4 h-4 relative" src="images/icon/filter-white.png" />
                                                <div className="text-white text-sm font-medium font-['Inter'] leading-normal" >Filtrar</div>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="justify-start items-center gap-2 flex">
                            {!isSearchActive ? (
                                // Conteúdo original da div "Pesquisar"
                                <div
                                    className="justify-start items-center gap-2 flex cursor-pointer"
                                    onClick={() => setIsSearchActive(true)} // Ativar o estado de pesquisa
                                >
                                    <img className="w-10 h-10 relative" src="images/icon/search.png" alt="Ícone Pesquisar" />
                                    <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Pesquisar</div>
                                </div>
                            ) : (
                                // Conteúdo alternativo ao ativar o estado de pesquisa
                                <div className="h-10 justify-start items-center gap-2 inline-flex">
                                    <div className="h-9 px-3 py-2 bg-white rounded-md border border-slate-300 justify-start items-center flex">
                                        <input
                                            type="text"
                                            placeholder="Pesquisar pelo nome"
                                            className="w-full text-slate-400 text-base font-normal font-['Inter'] leading-tight focus:outline-none"
                                            value={filters.nome}
                                            onChange={(e) =>
                                                setFilters({ ...filters, nome: e.target.value })
                                            }
                                        />
                                        <img className="w-6 h-6 p-[3.33px] justify-center items-center flex cursor-pointer" src="images/icon/close.png" onClick={() => {
                                            setIsSearchActive(false);
                                        }} />
                                    </div>
                                    <button
                                        className="px-4 py-2 bg-stone-600 rounded-md justify-center items-center gap-2 flex"
                                        onClick={handleSearch}
                                    >
                                        <img className="w-4 h-4 relative" src="images/icon/search-white.png" alt="Ícone Pesquisar" />
                                        <div className="text-white text-sm font-medium font-['Inter'] leading-normal">Pesquisar</div>
                                    </button>
                                </div>
                            )}
                        </div>
                        <div className="self-stretch flex justify-between gap-4">
                            {usePermission('EXPORTAR_CLIENTE') && (
                                <button type='button' className="flex px-4 py-2 bg-white/40 rounded-md border border-stone-600 justify-center items-center gap-2 cursor-pointer" onClick={exportToExcel}>
                                    <img className="w-4 h-4" src="images/icon/upload.png" />
                                    <div className="text-stone-600 text-sm font-medium font-['Inter'] leading-normal">Exportar</div>
                                </button>
                            )}
                            {usePermission('CRIAR_CLIENTE') && (
                                <button type='button' className="px-4 py-2 bg-stone-600 text-white rounded-md flex items-center gap-2" onClick={handleNavigateCadastrar}>
                                    <img className="w-4 h-4" src="images/icon/plus-circle.png" />
                                    <div className="text-white text-sm font-medium font-['Inter'] leading-normal" >Cadastrar</div>
                                </button>
                            )}
                        </div>
                    </div>
                </div>

                {/* Tabela */}
                <div className="overflow-x-auto md:overflow-x-visible">
                    <table className="min-w-full bg-white border-collapse border border-gray-200">
                        <thead className="bg-stone-200">
                            <tr>
                                {columns
                                    .filter((col) => col.visible)
                                    .map((col) => (
                                        <th className="px-4 py-2 border border-slate-200 text-slate-800 text-base font-bold">{col.label}</th>
                                    ))}
                            </tr>
                        </thead>
                        <tbody>
                            {clientes.map((cliente) => (
                                <tr key={cliente.id} >
                                    {columns
                                        .filter((col) => col.visible)
                                        .map((col) => (
                                            <td
                                                key={col.id}
                                                className="px-4 py-2 border border-slate-200 text-slate-700 text-base"
                                            >
                                                {col.formatter
                                                    ? col.formatter(cliente[col.id])
                                                    : cliente[col.id]}
                                            </td>
                                        ))}
                                </tr>
                            ))}
                        {totalRecords === 0 && (
                            <tr>
                                <td
                                    colSpan={columns.filter((col) => col.visible).length || 1}
                                    className="px-4 py-6 border border-slate-200 text-center text-slate-500 text-base"
                                >
                                    Nenhum registro encontrado.
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                {/* Paginação */}
                <div className="self-stretch justify-end items-center gap-2.5 inline-flex">
                    <div className="grow shrink basis-0 text-slate-500 text-base font-normal font-['Inter'] leading-[29.60px]">
                        Mostrando de {startRecord} até {endRecord} de {totalRecords}{" "} registros.
                    </div>
                    <div className="justify-start items-start gap-4 flex">
                        <button
                            className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-300 cursor-pointer"
                                }`}
                            disabled={currentPage === 1}
                            onClick={() => handlePageChange(currentPage - 1)}
                        >
                            <img className="w-6 h-6 relative" src="images/icon/keyboard-arrow-left.png" />
                        </button>

                        {pageNumbers.map((page) => (
                            <button
                                key={page}
                                className={`w-10 h-10 rounded  justify-center items-center flex text-base font-semibold font-['Inter'] ${page === currentPage
                                    ? "bg-stone-600 text-white"
                                    : "bg-gray-200 text-gray-600"
                                    }`}
                                onClick={() => handlePageChange(page)}
                            >
                                {page}
                            </button>
                        ))}
                        <button className={`w-10 h-10 bg-white/0 rounded border border-[#bebebe] justify-center items-center flex 
                        ${currentPage >= totalPages || totalPages === 0 ? 'opacity-30 cursor-not-allowed' : 'cursor-pointer'}`}
                            disabled={currentPage >= totalPages || totalPages === 0}
                            onClick={() => handlePageChange(currentPage + 1)}
                        >
                            <img className="w-6 h-6 relative" src="images/icon/keyboard-arrow-right.png" />
                        </button>
                    </div>
                </div>
            </div>

            {/* Modal de Sucesso */}
            {showSuccessDialog && (
                <AlertDialog
                    message={message}
                    onClose={() => setShowSuccessDialog(false)}
                />
            )}
        </Template>
    );
};

export default Clientes;

